import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Configuration } from '../../../app.constants';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-email-popup',
  templateUrl: './email-popup.component.html',
  styleUrls: ['./email-popup.component.css']
})
export class EmailPopupComponent implements OnInit {

  public mail = {subject: '' , message: ''};
  constructor(public dialogRef: MatDialogRef<EmailPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public configuration: Configuration) { }

  ngOnInit() {
  }
  proceed(){
    this.dialogRef.close(this.mail);
  }
  cancel(){
    this.dialogRef.close();
  }

}
